import dateTimeHelper from "../Helpers/datetimeHelper";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import JsxHelper from "../Helpers/JsxHelper";
import moneyHelper from "../Helpers/moneyHelper";
import PricingListItem from "./PricingListItem";
import stringHelper from "../Helpers/stringHelper";

class PricingOpportunityFieldWorkOfficeItem extends PricingListItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: PricingListItem.getSelectedCellHeader,
        orderById: "",
        data: PricingListItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        className: "text-center",
        minWidth: 30,
        tableminWidth: "35px",
      },
      { label: "Pricing Id", orderById: "PricingId", data: (item) => PricingListItem.GetPricingIdNavigationCellContent(item), type: FieldTypesEnum.Navigation },
      { label: "Service Name", orderById: "Service Name", data: "ServiceName" },
      { label: "Service Type", orderById: "ServiceType", data: "ServiceType" },
      { label: "FW Office", orderById: "OfficeName", data: "OfficeName" },
      { label: "Country Name", orderById: "CountryName", data: "CountryName", minWidth: 100 },
      { label: "FW Fee", orderById: "ClientFeeBase", data: (item) => moneyHelper.toMoneyFormat(item.ClientFeeBase, item.CurrencyName) },
      { label: "% Revenue", orderById: "NetRevenuePctBase", data: (item) => `${stringHelper.removeTrailingZeros(item.NetRevenuePctBase)} %`, minWidth: 80 },
      { label: "# Evals", orderById: "NumEvalsTotal", data: "NumEvalsTotal" },
      { label: "Status", orderById: "Status", data: "Status" },
      { label: "Assigned To", orderById: "AssignedToName", data: "AssignedToName", minWidth: 85 },
      { label: "Modified On", orderById: "ModifiedOn", data: (item) => dateTimeHelper.toYYYYsMMsDDWithIndefiniteIcon(item.ModifiedOn), minWidth: 85 },
      { label: "Comments?", orderById: "HasUserComments", data: (item) => JsxHelper.YesNo(item.HasUserComments), minWidth: 80 },
    ];
  }
}

export default PricingOpportunityFieldWorkOfficeItem;
